import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserveElementDirective } from './observer/observer.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ObserveElementDirective],
  exports: [ObserveElementDirective],
})
export class SharedDirectivesObserverModule {}
